import React, { useCallback, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'sonner';
import { useAuth } from '@/lib/api';
import CLTAnimation from '@/components/CLTAnimation';

function WelcomePage() {
    const navigate = useNavigate();
    const { clearJustLoggedIn } = useAuth();
    const completedRef = useRef(false);
    
    const handleAnimationComplete = useCallback(() => {
        if (completedRef.current) return;
        completedRef.current = true;
        clearJustLoggedIn();
        toast.success('Welcome to CLT Synapse');
        navigate('/home');
    }, [clearJustLoggedIn, navigate]);

    useEffect(() => {
        const timeout = window.setTimeout(handleAnimationComplete, 3500);
        return () => window.clearTimeout(timeout);
    }, [handleAnimationComplete]);
    
    return <CLTAnimation onComplete={handleAnimationComplete} />;
}

export default WelcomePage;
